export class registrationForm {
    constructor() {
        $(document).ready(function () {
            $('#emailRepeat').on('paste', function (e) {
                e.preventDefault();
            });
            $('#sfrCountry').on('change', function (e) {
                if ($('#sfrCountry').val() === 'USA') {
                    $('form .state').show();
                } else {
                    $('form .state').hide();
                }
            });
            if ($('#staticInfoCountry').val() === 'USA' || $('#sfrCountry').val() === 'USA') {
                $('form .state').show();
            } else {
                $('form .state').hide();
            }
        });
    }
}
